const table = {
    showingRange: '{{from}}–{{to}} of {{total}}',
    rowsPerPage: 'Rows per page',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    goToPage: 'Go to page {{page}}',
  };

export default table;
